export const CONST_LANGUAGE_TYPE_NONE = "None";
export const CONST_LANGUAGE_TYPE_PAIR = "Pair";
export const CONST_LANGUAGE_TYPE_SINGLE = "Single";
export const CONST_LANGUAGE_TYPE_SINGLE_DIRECTIONALITY = "Single/Directionality";

export const CONST_LANGUAGE_TYPES = [
    CONST_LANGUAGE_TYPE_NONE,
    CONST_LANGUAGE_TYPE_PAIR,
    CONST_LANGUAGE_TYPE_SINGLE,
    /*    CONST_LANGUAGE_TYPE_SINGLE_DIRECTIONALITY,*/
];

export const CONST_LANGUAGE_TYPES_SELECT = [
    { label: CONST_LANGUAGE_TYPE_NONE, value: CONST_LANGUAGE_TYPE_NONE },
    { label: CONST_LANGUAGE_TYPE_PAIR, value: CONST_LANGUAGE_TYPE_PAIR },
    { label: CONST_LANGUAGE_TYPE_SINGLE, value: CONST_LANGUAGE_TYPE_SINGLE },
    /*    { label: CONST_LANGUAGE_TYPE_SINGLE_DIRECTIONALITY, value: CONST_LANGUAGE_TYPE_SINGLE_DIRECTIONALITY },*/
];
